import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVviinnLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 130 32",
	style: { enableBackground: "new 0 0 130 32" },
	xmlSpace: "preserve",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "15,21.7 8.9,10 3,10 15,32 27.1,10 21.3,10 "
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "40.5,21.7 34.3,10 28.4,10 40.5,32 52.5,10 46.7,10 "
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 56.2,
			y: 10,
			className: "st0",
			width: 5.6,
			height: 21.3
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "st0",
			cx: 59,
			cy: 3.4,
			rx: 3.4,
			ry: 3.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 67.8,
			y: 10,
			className: "st0",
			width: 5.6,
			height: 21.3
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M70.7,0c-1.8,0-3.4,1.5-3.4,3.4s1.6,3.4,3.4,3.4c1.8,0,3.4-1.5,3.4-3.4S72.4,0,70.7,0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M89.8,9.3c-7.2,0-10.3,3.5-10.3,9.5v12.5h5.6V19.6c0-3.7,1.6-5.3,4.7-5.3c3.2,0,4.8,1.6,4.8,5.3v11.7h5.6V18.8 C100.2,12.8,97.2,9.3,89.8,9.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M116.6,9.3c-7.2,0-10.3,3.5-10.3,9.5v12.5h5.6V19.6c0-3.7,1.6-5.3,4.7-5.3c3.2,0,4.8,1.6,4.8,5.3v11.7h5.6V18.8 C127,12.8,123.9,9.3,116.6,9.3z"
		})
	]
});
export default SvgVviinnLogo;
